<template>
  <el-dialog
    :visible.sync="visible"
    :title="title"
    width="420px"
    :close-on-click-modal="false"
    custom-class="unbind-modal"
  >
    <p class="unbind-tip">
      <i class="el-icon-warning"></i>
      <span v-if="mode === 'unbind'">解绑后当前账号与该企业将解除关联，请确认操作</span>
      <span v-else>绑定新手机号后，原手机号将无法继续登录</span>
    </p>

    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="80px"
    >
      <el-form-item label="手机号" prop="phone">
        <el-input
          v-model="form.phone"
          :readonly="mode === 'unbind'"
          placeholder="请输入手机号"
        />
      </el-form-item>
      <el-form-item label="验证码" prop="code" class="code-row">
        <el-input v-model="form.code" placeholder="请输入短信验证码" />
        <button
          class="code-btn"
          :disabled="!countshow"
          @click="getCode"
        >{{ countshow ? '获取验证码' : `${count}s` }}</button>
      </el-form-item>
    </el-form>

    <template #footer>
      <button class="g-btn g-btn-default" @click="visible = false">取消</button>
      <button class="g-btn g-btn-primary" @click="submit">确认{{ mode === 'unbind' ? '解绑' : '绑定' }}</button>
    </template>
  </el-dialog>
</template>

<script>
import { unBinding, binding } from '@/lib/api/attestation'
import { getCode } from '@/lib/api/project'

export default {
  name: 'UnbindModal',
  props: {
    coId: { type: [String, Number], default: '' }
  },
  data () {
    return {
      visible: false,
      mode: 'unbind',
      timer: null,
      count: 60,
      countshow: true,
      form: { phone: '', code: '' },
      rules: {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      }
    }
  },
  computed: {
    title () {
      return this.mode === 'unbind' ? '解绑手机号' : '绑定新手机号'
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    open (mode = 'unbind', phone = '') {
      this.mode = mode
      this.form = { phone, code: '' }
      this.countshow = true
      this.visible = true
    },
    getCode () {
      if (!this.countshow) return
      if (!this.form.phone) return this.$message.warning('请先填写手机号')
      this.count = 60
      this.countshow = false
      this.timer = setInterval(() => {
        if (this.count > 0) this.count--
        else { this.countshow = true; clearInterval(this.timer); this.timer = null }
      }, 1000)
      getCode({ phone: this.form.phone }).then(() => this.$message.success('已发送'))
    },
    submit () {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        const fn = this.mode === 'unbind' ? unBinding : binding
        const payload = this.mode === 'unbind'
          ? { ...this.form }
          : { ...this.form, id: this.coId }
        fn(payload).then((res) => {
          if (res.code === 200) {
            this.$message.success('操作成功')
            this.visible = false
            this.$emit('success')
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.unbind-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: @warning-soft;
  border-radius: @radius-sm;
  color: @warning;
  font-size: 13px;
  margin-bottom: 16px;

  i { font-size: 16px; }
}

.code-row {
  ::v-deep .el-form-item__content {
    display: flex;
    gap: 10px;
    align-items: stretch;
  }

  .code-btn {
    height: 36px;
    border-radius: @radius-sm;
    border: 1px solid @primary;
    background: @primary-soft;
    color: @primary;
    padding: 0 14px;
    cursor: pointer;
    transition: all @duration-fast @ease-out;

    &:disabled {
      background: @bg-soft;
      color: @text-disabled;
      border-color: @border-base;
    }
  }
}
</style>
